import React, { useCallback, useState } from 'react'
import { useTranslation } from '@hooks/useTranslation'
import { Grid, Message } from 'semantic-ui-react'
import { InvoiceForm } from '@EUForms/invoice/invoiceForm'
import { CustomLoader } from '@commonComponents/formComponents/loader'
import ToggleButton from '@commonComponents/formComponents/toggleButton'
import ErrorBoundary from '@commonComponents/ErrorBoundary'
import InvoiceSummary from '@EUForms/invoice/InvoiceSummary'
import { AddBtn } from '@commonComponents/AddBtn'
import Merchandise from './Merchandise'
import { useDispatch, useSelector } from 'react-redux'
import { itemActions } from '../../reducer/ItemSlice'
import { useEvent } from '@hooks/useEvent'
import { selectSpecialCountryList } from '@EUForms/selectors'
import { addExtraSpace } from '@EUForms/utils'
import { createInvoiceStructure } from '../../util/itemsTabValidation'
import { deliveryKeys, fieldPatterns } from '../../util/fieldPatterns'
import { useCurrentShipmentType } from '@hooks/useCurrentShipmentType'
import { updateValidationErrors } from '../../reducer/validationSlice'
import validate from 'validate.js'
import { useContext } from 'react'
import { InvoiceToggleContext } from '@commonComponents/accordion/AccordianInvoice'


const Invoice = ({ invoiceId, invoiceIndex }) => {
  const {state}=useContext(InvoiceToggleContext)
  const active=state[invoiceId]
  const translate = useTranslation()
  const {isImportShipment} = useCurrentShipmentType()
  const fieldPattern = fieldPatterns(isImportShipment,translate)
  const { invoice } = fieldPattern()?.itemsTab
 
  const { isLoading, saveForm, deleteForm } = useEvent('invoiceTab', true)
  const dispatch = useDispatch()
  const {
    updateInvoiceHeader,
    deleteInvoice,
    createMerchandiseItem,
    updateInvoiceUpperHeader,
    updateMerchandiseItem,
  } = itemActions
  const countryList = useSelector(selectSpecialCountryList)
  const [activeAccordianIndex, setActiveAccordianIndex] = useState(false)
  const dataSource = useSelector(
    (state) => state.invoiceReducer.invoice.invoiceMap[invoiceId].invoiceHeader
  )
  const deleteData = useCallback(async () => {
    const response = await deleteForm({ invoiceIdList: [invoiceId] })
    if (response) {
      const invoiceUpperHeader = response?.invoiceTab?.invoiceUpperHeader
      invoiceUpperHeader && dispatch(updateInvoiceUpperHeader(invoiceUpperHeader))
      dispatch(deleteInvoice({ invoiceId }))
    }
  }, [invoiceId, deleteInvoice, deleteForm])

  const saveData = useCallback(
    async (payload) => {
      const response = await saveForm(
        {
          invoiceMap: {
            [invoiceId]: { invoiceId, invoiceHeader: { ...addExtraSpace(payload.data) } },
          },
        },
        false
      )
      if (response) {
        const invoiceUpperHeader = response?.invoiceTab?.invoiceUpperHeader
        invoiceUpperHeader && dispatch(updateInvoiceUpperHeader(invoiceUpperHeader))
        const invoiceMap = response?.invoiceTab?.invoiceMap
        const invoiceHeader = (invoiceMap && invoiceMap[invoiceId]?.invoiceHeader) || ''
        invoiceHeader && dispatch(updateInvoiceHeader({ invoiceId, data: invoiceHeader }))
        const merchandiseMap = response?.invoiceTab?.merchandiseMap
        if (merchandiseMap)
          for (let [key, val] of Object.entries(merchandiseMap)) {
            dispatch(updateMerchandiseItem({ merchandiseId: key, data: val }))
          }
      }
    },
    [saveForm, invoiceId]
  )
  const updateItem = useCallback(({  data }) => {
    dispatch(updateInvoiceHeader({ invoiceId, data }))
  }, [])
  const addMerchandise = useCallback(async () => {
    const response = await saveForm({ merchandiseMap: { '': { invoiceId } } }, true)
    if (response) {
      const merchandiseId = response.invoiceTab.merchandiseIdList[0]
      dispatch(createMerchandiseItem({ merchandiseId, invoiceId }))
    }
  }, [createMerchandiseItem, saveForm])


 

  const validateInvoice = (invoiceIndex, name, value) =>{

    let key = `invoice${invoiceIndex + 1}_deliveryTerms.${name}`
    let invErr = validate({deliveryTerms:{[name]:value}},{[deliveryKeys[name]]:invoice.deliveryTerms[deliveryKeys[name]]}) || {}
    invErr = createInvoiceStructure(invErr,invoiceIndex,translate)

    dispatch(updateValidationErrors({
      tabName: 'itemsTab',
      errors: {...invErr},
      errorKeys:[key]
    }))


  }

  
  return (
    <ErrorBoundary>
      <div className={'accordian-section tab-contentInvoice '}>
        <Message>
          {isLoading && <CustomLoader />}
          <ToggleButton
            id={`${active ? 'active': 'inActive'}-expandCollapseInvoice-${invoiceId}`}
            title={(isActive) =>
              isActive ? (
                translate('INVOICE')
              ) : (
                <InvoiceSummary id={invoiceId} dataSource={dataSource} translate={translate} />
              )
            }
            toggleId={invoiceId}
            lineNumber={invoiceIndex + 1}
            confirmationMsg='Invoice'
            onDelete={() => deleteData({ invoiceId })}
            buttonName='INVOICE'
            titleStyle={{ marginRight: '11.4rem' }}
          />
          {active && (
            <>
              <InvoiceForm
                dataSource={dataSource}
                translate={translate}
                saveItem={saveData}
                updateItem={updateItem}
                countryList={countryList}
                invoiceIndex={invoiceIndex}
                validateInvoice={validateInvoice}
              />
              <Merchandise invoiceId={invoiceId} invoiceIndex={invoiceIndex} />
              <AddBtn onClick={addMerchandise} text='ADD_LINE_ITEM' size='tiny' />
            </>
          )}
        </Message>
      </div>
    </ErrorBoundary>
  )
}

export default React.memo(Invoice)
